import { useEffect, useMemo } from 'react';
import { Box, Link, Paragraph } from '@alto-avios/alto-ui';
import Cookie from 'js-cookie';
import { useTranslation } from '@/utils/useTranslation';
import { useGlobalContext } from '@/components/GlobalProvider';
import { Programmes } from '@/utils/constants';

type Props = {
  link: string;
};

export const AlreadyMemberSection = ({ link }: Props) => {
  const { t } = useTranslation('alreadyMember');
  const { programmeId } = useGlobalContext();

  const opcoConfig = useMemo(() => {
    switch (programmeId) {
      case Programmes.BAEC:
        return {
          AVIOS_OPCO: 'BA',
          AVIOS_OPCO_LANG: 'en-GB',
          AVIOS_OPCO_MARKET: 'GB',
        };
      case Programmes.IBP:
        return {
          AVIOS_OPCO: 'IB',
          AVIOS_OPCO_LANG: 'es-ES',
          AVIOS_OPCO_MARKET: 'ES',
        };
      case Programmes.AERC:
        return {
          AVIOS_OPCO: 'EI',
          AVIOS_OPCO_LANG: 'en-GB',
          AVIOS_OPCO_MARKET: 'IE',
        };
      default:
        return undefined;
    }
  }, [programmeId]);

  useEffect(() => {
    if (!opcoConfig) {
      return;
    }

    if (Cookie.get('AVIOS_OPCO') === opcoConfig.AVIOS_OPCO) {
      return;
    }

    const cookieOptions = {
      sameSite: 'Lax' as const,
      expires: 30,
      path: '/',
      secure: process.env.NEXT_PUBLIC_ENVIRONMENT === 'prd',
    };

    Object.entries(opcoConfig).forEach(([key, value]) => {
      Cookie.set(key, value, cookieOptions);
    });
  }, [opcoConfig]);

  const memberLink = useMemo(() => link, [link]);

  return (
    <Box
      as="section"
      backgroundColor="transparent"
      borderRadius="xs"
      paddingX="2xl"
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="2xs"
    >
      <Link href={memberLink}>{t('link')}</Link>

      {programmeId === Programmes.BAEC && (
        <Paragraph
          size="sm"
          foregroundColor="accentSecondary"
          textAlign="center"
        >
          {t('logInNow')}
        </Paragraph>
      )}
    </Box>
  );
};
